import $ from 'jquery'

export const truncateAddress = (address) => {
  if (!address) return "No Account";
  const match = address.match(
    /^(0x[a-zA-Z0-9]{4})[a-zA-Z0-9]+([a-zA-Z0-9]{6})$/
  );
  if (!match) return address;
  return `${match[1]}…${match[2]}`;
};

export const toHex = (num) => {
   const val = Number(num);
   return "0x" + val.toString(16);
};

export const userAddress = (address) => {
   return address
}

export function formatDateAndtime(date) {
   var hours = date.getHours();
   var minutes = date.getMinutes();
   var ampm = hours >= 12 ? 'PM' : 'AM';
   hours = hours % 12;
   hours = hours ? hours : 12;
   minutes = minutes < 10 ? '0' + minutes : minutes;
   var strTime = hours + ':' + minutes + ' ' + ampm;
   return (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
}

export const providerURL = () => {
  const SCAN_LINK = {
    testnet: 'https://rpc.pulsechain.com',
    mainnet: 'https://rpc.pulsechain.com'
  }
  return SCAN_LINK.mainnet
}

export function txStart() {
   $("#check").removeClass('ready')
   $("#check").addClass('progressLoading')
   $("#pendingTrxPopUp, .pendingTrxPopUpShadow").show()
}
export function txDone() {
   $("#txStatusHeading").html("Transaction Completed")
   $("#check").removeClass('progressLoading')
   $("#check").addClass('ready')
}
export function txAfterDone() {
   $("#txStatusHeading").html("Transaction in Progress")
   $("#check").addClass('progressLoading')
   $("#check").removeClass('ready')
   $("#pendingTrxPopUp, .pendingTrxPopUpShadow").hide()
}